export const getUserData = () => {
  let userData = localStorage.getItem("userData");
  userData = JSON.parse(userData);
  return userData;
};

export const removeUserData = () => {
  localStorage.removeItem("userData");
};
